export function handleScrollIntoViewAndFocus(href, parent) {
  let lastKnownScrollPosition = 0;
  let ticking = false;

  const FPS = 30; // Give it at least 25ms or so, 0 or too small of a number would not work to animate scroll;
  const target = `#${href.split('#')[1]}`;

  function getParentY() {
    return parent.scrollY || parent.offsetTop;
  }

  function focusTarget(scrollPos, listenerToRemove) {
    setTimeout(() => {
      const topPos = getParentY();
      if (topPos === scrollPos) {
        document.querySelector(target).focus();
        parent.removeEventListener('scroll', listenerToRemove, false);
      }
    }, FPS);
  }

  function spyRequestAnimationFrame() {
    lastKnownScrollPosition = getParentY();
    if (!ticking) {
      parent.requestAnimationFrame(() => {
        focusTarget(lastKnownScrollPosition, spyRequestAnimationFrame);
        ticking = false;
      });
      ticking = true;
    }
  }

  parent.addEventListener('scroll', spyRequestAnimationFrame, false);
  document.querySelector(target).scrollIntoView({ behavior: 'smooth' });
}
